import React from "react";
import ProfilePageHeader from "components/Headers/ProfilePageHeader";

import Navbar from "components/Navbar";
import Footer from "components/Footer";

import News1 from "components/news/news1";
import News2 from "components/news/news2";
import News3 from "components/news/news3";
import News4 from "components/news/news4";
import News5 from "components/news/news5";
import News6 from "components/news/news6";
import News7 from "components/news/news7";

import { live } from "./content";

import ScrollUpButton from "react-scroll-up-button";

function News({ match }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  });
  const News = match.params.id;
  const n = live.find((x) => x.link === News);
  return (
    <div
      style={{
        // background: "#000",
        backgroundImage: "url(" + require("assets/images/services_bg.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      <Navbar />
      <ScrollUpButton />
      <section id="" />
      <ProfilePageHeader title={n.description} />
      {n.id === 1 && <News1 news={n} />}
      {n.id === 2 && <News2 news={n} />}
      {n.id === 3 && <News3 news={n} />}
      {n.id === 4 && <News4 news={n} />}
      {n.id === 5 && <News5 news={n} />}
      {n.id === 6 && <News6 news={n} />}
      {n.id === 7 && <News7 news={n} />}

      <Footer />
    </div>
  );
}

export default News;
